import { useTranslation } from "react-i18next";
import { Icon } from "@/components/Icon";
import { useInstallPrompt } from "./useInstallPrompt";

export function InstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, iosSafari, install, dismiss, hasNativePrompt } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div
      className="pwa-install-banner"
      role="region"
      aria-label={t("pwa.install.title")}
      style={{ marginTop: 16 }}
    >
      <div className="pwa-install-banner__content">
        <p className="pwa-install-banner__title">{t("pwa.install.title")}</p>
        <p className="pwa-install-banner__body">
          {iosSafari && !hasNativePrompt ? t("pwa.install.iosHint") : t("pwa.install.body")}
        </p>
      </div>
      <div className="pwa-install-banner__actions">
        {hasNativePrompt ? (
          <button type="button" className="btn btn-primary btn-sm" onClick={() => void install()}>
            {t("pwa.install.install")}
          </button>
        ) : null}
        <button
          type="button"
          className="btn btn-quiet btn-sm pwa-install-banner__dismiss"
          onClick={dismiss}
          aria-label={t("pwa.install.dismiss")}
        >
          <Icon name="x" size={14} />
        </button>
      </div>
    </div>
  );
}
